module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_225deg.43b37a9a.png";